import { render, staticRenderFns } from "./PuzzleCell.vue?vue&type=template&id=4548375c&scoped=true&"
import script from "./PuzzleCell.vue?vue&type=script&lang=js&"
export * from "./PuzzleCell.vue?vue&type=script&lang=js&"
import style0 from "./PuzzleCell.vue?vue&type=style&index=0&id=4548375c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4548375c",
  null
  
)

export default component.exports